import React from 'react';
import styled from 'styled-components';
import Menu from '../../../components/Menu/Navbar'
import Header from '../../../components/Header/header'
import Logo from '../../../components/Logo/logo'
import Footer from '../../../components/Footer/footer'
import FxView from '../../../components/FxView/fxview'
import { supabase } from '../../../supabaseClient';
import { useState, useEffect } from 'react';

const ContainerGeneral = styled.div`
  margin: 0px auto; 
  width: 75%; 
  padding: 40px;
min-height: 100vh;



  border-radius: 10px;

  @media (max-width: 768px) {
    width: 100%;
       margin: 0px auto; 
  }
`;

const HeaderClub = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  flex-wrap: wrap;
`;

const LogoClub = styled.img`
  width: 180px;
  height: auto;


  @media (max-width: 768px) {
  
       width: 100px;
  }
`;

const TituloClub = styled.h1`
  color: #ffffff;
  font-weight: bold;
  margin: 0;
  text-align: center;

  /* 🔥 tamaño dinámico según pantalla */
  font-size: clamp(19px, 5vw, 60px);

  /* Evitar que el texto se rompa en varias líneas */
  white-space: nowrap;

  letter-spacing: 3px;

  @media (max-width: 768px) {
    /* Reducir ligeramente el tamaño en móvil para que quepa en una línea */
    font-size: 6vw;
  }
`;

const TituloGrande = styled.h1`
  font-family: 'GarnetLight';
  font-weight: bold;
  margin: 10px 0;
  margin-top: 10px ;
  text-align: center;
  color: #a0f000;
  font-size: 25px;

  @media (max-width: 768px) {
  
      font-size: 16px;
  }
`;

const GridPistas = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
  margin-top: 40px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const PistaCard = styled.div`
  text-align: center;
`;

const NumeroPista = styled.p`
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 20px;
   font-size: 28px;
    margin-top: 40px;
    
`;

const ImagenPista = styled.img`
  width: 100%;
  border-radius: 8px;
  border: 2px solid #fff;
`;

const Indicador = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin: 10px auto 0;
  cursor: pointer;

  background-color: ${(props) =>
    props.estado === 'libre' ? '#00ff00' : '#ff0000'};
`;


const FondoPagina = styled.div`
  background: radial-gradient(
    circle at center,
    #2f6fb3 0%,
    #1e4f8a 40%,
    #0d2f5f 100%
  );
  min-height: 100vh;
`;

const EscuelaDeFormacion = () => {

const [pistas, setPistas] = useState([]);





const [isAdmin, setIsAdmin] = useState(false);

useEffect(() => {
  fetchPistas();
  checkUserRole();
}, []);

const checkUserRole = () => {
  const userRole = localStorage.getItem('rolUsuario');
  if (userRole === 'admin') {
    setIsAdmin(true);
  }
};



useEffect(() => {
  fetchPistas();
}, []);

const fetchPistas = async () => {
  const { data, error } = await supabase
    .from('pistas')
    .select('*')
    .order('numero', { ascending: true });

  if (error) {
    console.error(error);
  } else {
    setPistas(data);
  }
};

console.log("PISTAS:", pistas);

const toggleEstado = async (pista) => {
  const nuevoEstado = pista.estado === 'libre' ? 'ocupada' : 'libre';

  const { error } = await supabase
    .from('pistas')
    .update({ estado: nuevoEstado })
    .eq('id', pista.id);

  if (error) {
    console.error(error);
  } else {
    // actualizar en pantalla sin recargar
    setPistas((prev) =>
      prev.map((p) =>
        p.id === pista.id ? { ...p, estado: nuevoEstado } : p
      )
    );
  }
};


  return (
    <div>
      <FondoPagina>
      <Menu />
      <Header />
      <Logo />
      <FxView />
      <ContainerGeneral>



<HeaderClub>
  <LogoClub 
    src={`${process.env.PUBLIC_URL}/BELLAVISTA.png`} 
    alt="Logo Bellavista" 
  />
  <TituloClub>BELLAVISTA HUELVA CLUB</TituloClub>
</HeaderClub>

        <TituloGrande>ESTADO DE LAS PISTAS DE TENIS</TituloGrande>

<GridPistas>
 {pistas.map((pista) => (
  <PistaCard key={pista.id}>
    <NumeroPista>PISTA {pista.numero}</NumeroPista>

    <ImagenPista
      src={`${process.env.PUBLIC_URL}/Imagenpistadetenis.jpeg`}
      alt={`Pista ${pista.numero}`}
    />

    <Indicador
      estado={pista.estado}
      onClick={() => {
  if (isAdmin) toggleEstado(pista);
}}
    />
  </PistaCard>
))}
</GridPistas>


      </ContainerGeneral>
      <Footer />
      </FondoPagina>
    </div>
  );
};

export default EscuelaDeFormacion;